import Vue from 'vue'
import { declOfNum } from '@/utils'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'

dayjs.locale('ru')

Vue.filter('phone', phone => {
  /* eslint-disable */
  try {
    return phone
      .replace(/[^\d]/g, '')
      .replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, '($1) $2-$3-$4')
  } catch (e) {}
})

Vue.filter('date', (date, format = 'D MMM YYYY') => {
  /* eslint-disable */
  try {
    return typeof date === 'string'
      ? dayjs(date).format(format)
      : date.format(format)
  } catch (e) {}
})

Vue.filter('time', (date, format = 'HH:mm') => {
  /* eslint-disable */
  try {
    return typeof date === 'string'
      ? dayjs(date).format(format)
      : date.format(format)
  } catch (e) {}
})

// Отображает рубли примерно так 453 026 ₽
Vue.filter('rubles', val => {
  return Vue.options.filters.currency(val, '₽', 0, {
    thousandsSeparator: ' ',
    symbolOnLeft: false,
    spaceBetweenAmountAndSymbol: true
  })
})

Vue.filter('declofnum', (number, titles) => {
  return declOfNum(number, titles)
})
